import { call, fork, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import FlowsClient from 'rest/FlowsClient';
import { errorAction } from 'components/utility/actions';
import * as actions from './actions';
const { types } = actions;

export const flowsClient = new FlowsClient();

// TODO: This requires renaming to fetchFlows as it no longer fetches flow-triggers.
export function *fetchTriggers(action) {
	try {
		const response = yield call([
			flowsClient,
			flowsClient.getFlowsSummaries
		]);
		yield put({
			payload: response.data,
			type: types.FETCH_TRIGGERS_SUCCESS
		});
	} catch (error) {
		yield put(errorAction(types.FETCH_TRIGGERS_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeEvery, types.FETCH_TRIGGERS, fetchTriggers);
}
